/* Crochuito – pages: cart, story chapters, contact, FAQ, shop opening (v6) */
(function () {
  'use strict';
  if (window.CSPages) return;
  var d = document, de = d.documentElement, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var R = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var desk = w.matchMedia('(min-width: 990px)');
  var hasIO = 'IntersectionObserver' in w;
  var scrollers = [], measurers = [], ticking = false;

  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function T(k, fb) { return (w.CS_I18N && w.CS_I18N[k]) || fb; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; scrollers.forEach(function (f) { f(); }); });
  }
  function measure() { measurers.forEach(function (f) { f(); }); onScroll(); }

  /* =========================================================
     Cart (slide-over + cart page): quantities, removal, note
     ========================================================= */
  var Cart = (function () {
    var chain = Promise.resolve(), timers = {}, highlight = null, lastTrigger = null, hideT = 0, settleT = 0, noteT = 0;
    var fsDone = {};

    function roots() { return $$('[data-cs-cart]'); }
    function ids() { return roots().map(function (r) { return r.getAttribute('data-cs-cart'); }).filter(Boolean); }
    function drawer() { return d.querySelector('[data-cs-cart-drawer]'); }
    function queue(fn) { chain = chain.then(fn, fn); return chain; }
    function setBusy(on) { $$('[data-cs-cart-body]').forEach(function (b) { b.classList.toggle('is-busy', on); }); }
    function itemOf(el) { return el && el.closest ? el.closest('.cs-cb__item') : null; }
    function findItem(key) { return $$('.cs-cb__item').filter(function (x) { return x.getAttribute('data-key') === key; })[0] || null; }
    function showError(item, msg) {
      if (!item) return;
      var e = item.querySelector('[data-cs-cart-error]');
      if (e) { e.textContent = msg; e.hidden = false; }
    }
    function noteFs() {
      roots().forEach(function (root) {
        var id = root.getAttribute('data-cs-cart');
        if (id && !(id in fsDone)) fsDone[id] = !!root.querySelector('.cs-fs.is-done');
      });
    }

    function focusId(el) {
      var item = itemOf(el), role = null;
      if (el.hasAttribute('data-cs-cart-step')) role = el.getAttribute('data-cs-cart-step') === '1' ? 'up' : 'down';
      else if (el.hasAttribute('data-cs-cart-input')) role = 'input';
      else if (el.hasAttribute('data-cs-cart-remove')) role = 'remove';
      else if (el.hasAttribute('data-cs-cart-note')) role = 'note';
      if (!role) return null;
      return { key: item ? item.getAttribute('data-key') : null, role: role };
    }
    function findFocus(scope, f) {
      var sel = { up: '[data-cs-cart-step="1"]', down: '[data-cs-cart-step="-1"]', input: '[data-cs-cart-input]', remove: '[data-cs-cart-remove]', note: '[data-cs-cart-note]' }[f.role];
      var base = scope;
      if (f.key) base = $$('.cs-cb__item', scope).filter(function (x) { return x.getAttribute('data-key') === f.key; })[0];
      return base ? base.querySelector(sel) : null;
    }

    function swap(sections) {
      if (!sections) return;
      var swapped = false;
      roots().forEach(function (root) {
        var id = root.getAttribute('data-cs-cart');
        var html = sections[id];
        if (!html) return;
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cs-cart-body]'), old = root.querySelector('[data-cs-cart-body]');
        if (!fresh || !old) return;
        var oldDyn = old.querySelector('.cs-cb__dyn'), newDyn = fresh.querySelector('.cs-cb__dyn');
        if (oldDyn && newDyn) newDyn.parentNode.replaceChild(oldDyn, newDyn);
        var oldNote = old.querySelector('details.cs-cb__note'), newNote = fresh.querySelector('details.cs-cb__note');
        if (oldNote && newNote) newNote.open = oldNote.open;
        var oldMain = old.querySelector('.cs-cb__main'), st = oldMain ? oldMain.scrollTop : 0;
        var oldTotal = old.querySelector('[data-cs-cart-total]'), newTotal = fresh.querySelector('[data-cs-cart-total]');
        var a = d.activeElement, f = a && old.contains(a) ? focusId(a) : null;
        old.parentNode.replaceChild(fresh, old);
        swapped = true;
        var newMain = fresh.querySelector('.cs-cb__main');
        if (newMain && st) newMain.scrollTop = st;
        if (f) {
          var t = findFocus(fresh, f) || fresh.querySelector('[data-cs-cart-checkout], .cs-cb__empty .cs-btn, [data-cs-cart-close]');
          if (t) t.focus({ preventScroll: true });
        }
        if (highlight && root.closest('[data-cs-cart-drawer]')) {
          var it = fresh.querySelector('.cs-cb__item[data-variant="' + highlight + '"]');
          if (it) it.classList.add('is-new');
        }
        // a short accent when the total changes, and a small moment when free shipping is reached
        if (!reduce && oldTotal && newTotal && oldTotal.textContent.trim() !== newTotal.textContent.trim()) newTotal.classList.add('is-changed');
        var fs = fresh.querySelector('.cs-fs'), done = !!(fs && fs.classList.contains('is-done'));
        if (done && fsDone[id] === false && !reduce) fs.classList.add('is-celebrate');
        fsDone[id] = done;
      });
      highlight = null;
      if (swapped) d.dispatchEvent(new CustomEvent('cs:cart-swapped'));
    }

    function emit(cart) {
      var res = {};
      for (var k in cart) if (k !== 'sections') res[k] = cart[k];
      d.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res, sourceId: 'cs-cart', data: { itemCount: res.item_count, source: 'cs-cart' } } }));
    }

    function post(path, payload, withSections) {
      if (withSections !== false) {
        var list = ids();
        if (list.length) { payload.sections = list.join(','); payload.sections_url = w.location.pathname; }
      }
      return fetch(R + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) { var e = new Error(j.description || j.message || T('error', 'Something went wrong')); e.status = r.status; throw e; }
            return j;
          });
        });
    }

    // Re-render every cart on the page through the Section Rendering API (section_id on the current URL
    // returns the section's HTML; /cart?sections= with a JSON Accept header returns the cart itself instead).
    function refresh() {
      var list = ids();
      if (!list.length) return Promise.resolve();
      var out = {};
      return Promise.all(list.map(function (id) {
        var u = new URL(w.location.href);
        u.hash = '';
        u.searchParams.delete('sections');
        u.searchParams.set('section_id', id);
        return fetch(u.toString(), { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (h) { if (h) out[id] = h; })
          .catch(function () {});
      })).then(function () { swap(out); }).catch(function () {});
    }

    function collapse(item) {
      if (reduce || !item.animate) { item.style.opacity = '.35'; return null; }
      var h = item.offsetHeight;
      item.style.overflow = 'hidden';
      var anim = item.animate(
        [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px' }],
        { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }
      );
      return anim.finished ? anim.finished.catch(function () {}) : null;
    }

    function change(item, qty) {
      if (!item) return;
      var key = item.getAttribute('data-key');
      var body = item.closest('[data-cs-cart-body]');
      var max = parseInt(item.getAttribute('data-max'), 10);
      var err = item.querySelector('[data-cs-cart-error]');
      if (err) err.hidden = true;
      if (!isNaN(max) && qty > max) {
        qty = max;
        showError(item, (body && body.getAttribute('data-label-only') || 'Only [n] available.').replace('[n]', max));
      }
      var input = item.querySelector('[data-cs-cart-input]');
      if (input) input.value = qty;
      var up = item.querySelector('[data-cs-cart-step="1"]');
      if (up) up.disabled = !isNaN(max) && qty >= max;
      item.classList.add('is-busy');
      var anim = qty === 0 ? collapse(item) : null;
      clearTimeout(timers[key]);
      timers[key] = setTimeout(function () {
        delete timers[key];
        setBusy(true);
        queue(function () {
          return Promise.all([post('cart/change.js', { id: key, quantity: qty }), anim])
            .then(function (out) { swap(out[0].sections); emit(out[0]); })
            .catch(function (e) { return refresh().then(function () { showError(findItem(key), e.message); }); });
        }).then(function () { setBusy(false); });
      }, qty === 0 ? 0 : 350);
    }

    function saveNote(field) {
      var val = field.value;
      queue(function () {
        return post('cart/update.js', { note: val }, false).then(function () {
          $$('[data-cs-cart-note]').forEach(function (x) { if (x !== field && x.value !== val) x.value = val; });
          var body = field.closest('[data-cs-cart-body]'), saved = field.parentNode.querySelector('[data-cs-cart-saved]');
          if (saved) {
            saved.textContent = (body && body.getAttribute('data-label-saved')) || 'Saved';
            saved.classList.add('is-on');
            clearTimeout(saved._t);
            saved._t = setTimeout(function () { saved.classList.remove('is-on'); saved.textContent = ''; }, 1800);
          }
        }).catch(function () {});
      });
    }

    function show(trigger) {
      var el = drawer();
      if (!el) return false;
      clearTimeout(hideT);
      lastTrigger = trigger || d.activeElement;
      if (!el.open) {
        el.classList.remove('is-settled');
        if (typeof el.showModal === 'function') el.showModal(); else el.setAttribute('open', '');
      }
      de.classList.add('cs-cd-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
      clearTimeout(settleT);
      settleT = setTimeout(function () { el.classList.add('is-settled'); }, 1500);
      var c = el.querySelector('[data-cs-cart-close]');
      if (c) c.focus({ preventScroll: true });
      return true;
    }
    function hide() {
      var el = drawer();
      if (!el || !el.open) return;
      el.classList.remove('is-open');
      de.classList.remove('cs-cd-open');
      clearTimeout(hideT);
      hideT = setTimeout(function () {
        if (el.open) { if (typeof el.close === 'function') el.close(); else el.removeAttribute('open'); }
        el.classList.remove('is-settled');
        if (lastTrigger && lastTrigger.focus && d.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      }, reduce ? 0 : 460);
    }

    function boot() {
      noteFs();
      var el = drawer();
      if (el && !el._cd) {
        el._cd = 1;
        el.addEventListener('cancel', function (e) { e.preventDefault(); hide(); });
        el.addEventListener('click', function (e) { if (e.target === el) hide(); });
      }
    }

    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('[data-cs-cart-open]');
      if (opener) { if (drawer()) { e.preventDefault(); show(opener); } return; }
      if (t.closest('[data-cs-cart-close]')) { e.preventDefault(); hide(); return; }
      var step = t.closest('[data-cs-cart-step]');
      if (step) {
        var it = itemOf(step), inp = it && it.querySelector('[data-cs-cart-input]');
        if (!inp) return;
        change(it, Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(step.getAttribute('data-cs-cart-step'), 10)));
        return;
      }
      var rm = t.closest('[data-cs-cart-remove]');
      if (rm) { e.preventDefault(); change(itemOf(rm), 0); }
    });
    d.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-cs-cart-input]')) {
        var q = parseInt(t.value, 10);
        change(itemOf(t), isNaN(q) || q < 0 ? 0 : q);
      }
    });
    d.addEventListener('keydown', function (e) {
      var t = e.target;
      if (e.key === 'Enter' && t && t.matches && t.matches('[data-cs-cart-input]')) { e.preventDefault(); t.blur(); }
    });
    d.addEventListener('input', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-cs-cart-note]')) {
        clearTimeout(noteT);
        noteT = setTimeout(function () { saveNote(t); }, 650);
      }
    });
    d.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('[data-cs-cart-form]')) {
        $$('[data-cs-cart-checkout], [data-cs-cart-mbar] .cs-btn').forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      }
    });
    d.addEventListener('cart:update', function (e) {
      var src = e.detail && e.detail.sourceId;
      if (src !== 'cs-cart') refresh();
    });
    d.addEventListener('cs:added', function (e) {
      var res = e.detail || {}, item = res.item || {};
      highlight = item.variant_id || item.id || null;
      if (!drawer()) return;
      var qv = d.querySelector('.cs-qvd[open]');
      setTimeout(function () { show(null); }, qv ? 380 : 40);
    });
    w.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      $$('[data-cs-cart-checkout].is-loading, [data-cs-cart-mbar] .cs-btn.is-loading').forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      refresh();
    });

    return { boot: boot, open: show, close: hide, refresh: refresh };
  })();

  /* =========================================================
     Pinned story (about chapters, product close-up, account steps)
     ========================================================= */
  function initScrolly(scope) {
    $$('[data-cs-scrolly]', scope).forEach(function (sec) {
      if (sec._sc) return;
      sec._sc = 1;
      var steps = $$('[data-cs-scrolly-step]', sec), frames = $$('[data-cs-scrolly-frame]', sec);
      var cur = sec.querySelector('[data-cs-scrolly-current]'), bar = sec.querySelector('[data-cs-scrolly-bar]');
      var ticks = $$('.cs-pstory__ticks i', sec);
      if (!steps.length) return;
      var active = -1;
      function activate(i) {
        if (i < 0 || i === active) return;
        active = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        var f = parseInt(steps[i].getAttribute('data-frame'), 10);
        if (isNaN(f)) f = i;
        frames.forEach(function (fr, k) { fr.classList.toggle('is-active', k === f); fr.classList.toggle('is-past', k < f); });
        if (cur) cur.textContent = pad(i + 1);
        ticks.forEach(function (t, k) { t.classList.toggle('is-on', k <= i); });
      }
      sec._activate = activate;
      activate(0);
      if (!hasIO || design) return;
      var io = new IntersectionObserver(function (es) {
        if (!desk.matches) return;
        es.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
      }, { rootMargin: '-48% 0px -48% 0px' });
      steps.forEach(function (s) { io.observe(s); });
      if (bar) scrollers.push(function () {
        if (!desk.matches) return;
        var r = steps[0].parentNode.getBoundingClientRect();
        bar.style.setProperty('--cs-sp', clamp((w.innerHeight * 0.5 - r.top) / Math.max(1, r.height), 0, 1).toFixed(4));
      });
    });
  }

  /* =========================================================
     Contact: order number only for orders, live checks, copy
     ========================================================= */
  function initContact(scope) {
    $$('[data-cs-contact]', scope).forEach(function (form) {
      if (form._ct) return;
      form._ct = 1;
      form.noValidate = true;
      var orderField = form.querySelector('[data-cs-order-field]');
      var radios = $$('[data-cs-topic]', form);
      function sync() {
        if (!orderField) return;
        var sel = radios.filter(function (r) { return r.checked; })[0];
        var on = !sel || sel.getAttribute('data-cs-topic') === '1';
        orderField.classList.toggle('is-collapsed', !on);
        var inp = orderField.querySelector('input');
        if (inp) inp.disabled = !on;
      }
      radios.forEach(function (r) { r.addEventListener('change', sync); });
      sync();
      var fields = $$('.cs-field', form);
      function check(field, showErr) {
        var el = field.querySelector('input, textarea');
        if (!el || el.disabled) return true;
        var ok = el.checkValidity(), filled = el.value.trim() !== '';
        field.classList.toggle('is-valid', ok && filled && el.required);
        if (showErr) {
          field.classList.toggle('is-invalid', !ok);
          el.setAttribute('aria-invalid', ok ? 'false' : 'true');
          var msg = field.querySelector('.cs-field__err');
          if (!ok) {
            if (!msg) {
              msg = d.createElement('small');
              msg.className = 'cs-field__err';
              msg.id = el.id + '-err';
              field.appendChild(msg);
              el.setAttribute('aria-describedby', msg.id);
            }
            msg.textContent = el.validationMessage;
          } else if (msg) {
            msg.parentNode.removeChild(msg);
            el.removeAttribute('aria-describedby');
          }
        }
        return ok;
      }
      fields.forEach(function (f) {
        var el = f.querySelector('input, textarea');
        if (!el) return;
        el.addEventListener('blur', function () { if (el.value.trim() !== '' || f.classList.contains('is-invalid')) check(f, true); });
        el.addEventListener('input', function () { check(f, f.classList.contains('is-invalid')); });
      });
      form.addEventListener('submit', function (e) {
        var bad = null;
        fields.forEach(function (f) { if (!check(f, true) && !bad) bad = f; });
        if (bad) {
          e.preventDefault();
          var el = bad.querySelector('input, textarea');
          if (el) el.focus();
          return;
        }
        var btn = form.querySelector('[data-cs-submit]');
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      });
    });
  }
  function copy(b) {
    var text = b.getAttribute('data-cs-copy') || '';
    var label = b.querySelector('[data-cs-copy-label]');
    function done() {
      if (label && !label.hasAttribute('data-orig')) label.setAttribute('data-orig', label.textContent);
      if (label) label.textContent = b.getAttribute('data-label-done') || label.textContent;
      b.classList.add('is-done');
      clearTimeout(b._t);
      b._t = setTimeout(function () { b.classList.remove('is-done'); if (label) label.textContent = label.getAttribute('data-orig'); }, 2200);
    }
    function fallback() {
      var ta = d.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      d.body.appendChild(ta); ta.select();
      try { if (d.execCommand('copy')) done(); } catch (err) {}
      d.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, fallback); else fallback();
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-cs-copy]');
    if (b) copy(b);
  });

  /* =========================================================
     FAQ: topic links that follow the page, instant search
     ========================================================= */
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function mark(el, terms) {
    var walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var text = node.nodeValue, lower = text.toLowerCase(), ranges = [];
      terms.forEach(function (t) {
        var i = 0;
        while (t && (i = lower.indexOf(t, i)) > -1) { ranges.push([i, i + t.length]); i += t.length; }
      });
      if (!ranges.length) return;
      ranges.sort(function (a, b) { return a[0] - b[0]; });
      var merged = [];
      ranges.forEach(function (r) { var last = merged[merged.length - 1]; if (last && r[0] <= last[1]) last[1] = Math.max(last[1], r[1]); else merged.push(r.slice()); });
      var frag = d.createDocumentFragment(), pos = 0;
      merged.forEach(function (r) {
        if (r[0] > pos) frag.appendChild(d.createTextNode(text.slice(pos, r[0])));
        var m = d.createElement('mark'); m.textContent = text.slice(r[0], r[1]); frag.appendChild(m);
        pos = r[1];
      });
      if (pos < text.length) frag.appendChild(d.createTextNode(text.slice(pos)));
      node.parentNode.replaceChild(frag, node);
    });
  }
  function initFaq(scope) {
    $$('[data-cs-faqnav]', scope).forEach(function (nav) {
      if (nav._fq) return;
      var secs = $$('section.cs-faq[id]');
      if (!secs.length) return;
      nav._fq = 1;
      nav.classList.add('is-ready');
      var topics = nav.querySelector('[data-cs-faq-topics]'), input = nav.querySelector('[data-cs-faq-q]'), clear = nav.querySelector('[data-cs-faq-clear]');
      var status = nav.querySelector('[data-cs-faq-status]'), empty = nav.querySelector('[data-cs-faq-empty]'), emptyText = nav.querySelector('[data-cs-faq-emptytext]');
      var barEl = nav.querySelector('.cs-faqnav__bar');
      topics.textContent = '';
      var links = secs.map(function (sec) {
        var label = sec.querySelector('.cs-eyebrow'), h = sec.querySelector('h2');
        var a = d.createElement('a');
        a.href = '#' + sec.id;
        a.textContent = (label && label.textContent.trim()) || (h && h.textContent.trim()) || sec.id;
        a.addEventListener('click', function (ev) {
          ev.preventDefault();
          sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          try { history.replaceState(history.state, '', '#' + sec.id); } catch (err) {}
        });
        topics.appendChild(a);
        return a;
      });
      var items = [];
      secs.forEach(function (sec, si) {
        $$('details', sec).forEach(function (det) {
          var sum = det.querySelector('summary'), q = null;
          if (sum) {
            // highlight inside one text wrapper, so <mark> never becomes its own flex item in the summary row
            q = sum.querySelector('.cs-faq__q');
            if (!q) {
              q = d.createElement('span');
              q.className = 'cs-faq__q';
              Array.prototype.slice.call(sum.childNodes).forEach(function (n) {
                if (!(n.nodeType === 1 && n.tagName === 'I')) q.appendChild(n);
              });
              sum.insertBefore(q, sum.firstChild);
            }
          }
          items.push({ det: det, sec: si, sum: q, text: norm(det.textContent), html: q ? q.innerHTML : '', open: det.open });
        });
      });
      var activeIdx = -1;
      function setActive(i) {
        if (i === activeIdx || i < 0) return;
        activeIdx = i;
        links.forEach(function (a, k) { a.classList.toggle('is-active', k === i); if (k === i) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        var a = links[i];
        if (a && topics.scrollWidth > topics.clientWidth) topics.scrollTo({ left: a.offsetLeft - topics.clientWidth / 2 + a.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (hasIO) {
        var spy = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) setActive(secs.indexOf(e.target)); });
        }, { rootMargin: '-35% 0px -60% 0px' });
        secs.forEach(function (s) { spy.observe(s); });
      }
      // after filtering, bring the first answer (or the empty state) right under the search bar
      function bringIntoView() {
        var target = null;
        for (var k = 0; k < secs.length; k++) if (!secs[k].hidden) { target = secs[k].querySelector('.cs-faq__grid') || secs[k]; break; }
        if (!target && empty && !empty.hidden) target = empty;
        if (!target || !barEl) return;
        var head = barEl.parentNode || barEl; // the bar plus the result count under it
        var limit = Math.max(barEl.getBoundingClientRect().bottom + 28, head.getBoundingClientRect().bottom + 18);
        var top = target.getBoundingClientRect().top;
        if (top < limit - 4 || top > w.innerHeight * 0.55) {
          w.scrollTo({ top: Math.max(0, w.scrollY + top - limit), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      var searching = false, timer = 0, lastQ = '';
      function run() {
        var raw = input.value.trim(), q = norm(raw);
        var terms = q.split(/\s+/).filter(Boolean), rawTerms = raw.toLowerCase().split(/\s+/).filter(Boolean);
        clear.hidden = !input.value;
        nav.classList.toggle('has-query', !!input.value);
        if (terms.length && !searching) { items.forEach(function (it) { it.open = it.det.open; }); searching = true; }
        var count = 0, perSec = secs.map(function () { return 0; });
        items.forEach(function (it) {
          var match = !terms.length || terms.every(function (x) { return it.text.indexOf(x) > -1; });
          it.det.hidden = !match;
          if (it.sum) it.sum.innerHTML = it.html;
          if (match) { count++; perSec[it.sec]++; }
        });
        secs.forEach(function (sec, k) {
          var none = terms.length > 0 && perSec[k] === 0;
          sec.hidden = none;
          links[k].classList.toggle('is-dim', none);
        });
        if (terms.length) {
          items.forEach(function (it) {
            if (it.det.hidden) return;
            if (it.sum) mark(it.sum, rawTerms);
            it.det.open = count <= 3;
          });
          status.textContent = count === 1 ? nav.getAttribute('data-label-one') : count > 1 ? nav.getAttribute('data-label-many').replace('[n]', count) : '';
          empty.hidden = count > 0;
          if (!count) emptyText.textContent = nav.getAttribute('data-label-none').replace('[q]', raw);
        } else {
          status.textContent = '';
          empty.hidden = true;
          if (searching) { items.forEach(function (it) { it.det.open = it.open; }); searching = false; }
        }
        if (q !== lastQ) {
          lastQ = q;
          if (terms.length) requestAnimationFrame(bringIntoView);
        }
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { input.value = ''; run(); } });
      input.addEventListener('search', run);
      clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    });
  }

  /* =========================================================
     Shop: opening image widens to full width, sticky toolbar
     ========================================================= */
  function initWiden(scope) {
    $$('[data-cs-widen]', scope).forEach(function (stage) {
      if (stage._wd) return;
      stage._wd = 1;
      var band = stage.querySelector('[data-cs-widen-target]');
      if (!band || reduce || design) return;
      var maxInset = 0, docTop = 1, radius = 32;
      function m() {
        var wrap = stage.parentNode;
        var cs = getComputedStyle(wrap);
        maxInset = Math.max(0, wrap.getBoundingClientRect().left + (parseFloat(cs.paddingLeft) || 0));
        docTop = Math.max(1, stage.getBoundingClientRect().top + w.scrollY - w.innerHeight * 0.12);
        radius = parseFloat(getComputedStyle(de).getPropertyValue('--cs-radius-lg')) || 32;
      }
      m();
      measurers.push(m);
      scrollers.push(function () {
        var r = stage.getBoundingClientRect();
        if (r.bottom < -50 || r.top > w.innerHeight + 50) return;
        var p = ease(clamp(w.scrollY / docTop, 0, 1));
        band.style.setProperty('--inset', (maxInset * (1 - p)).toFixed(1) + 'px');
        band.style.setProperty('--r', (radius * (1 - p)).toFixed(1) + 'px');
        band.style.setProperty('--bs', (1.08 - 0.08 * p).toFixed(4));
      });
    });
  }
  function initSticky(scope) {
    $$('[data-cs-sticky]', scope).forEach(function (bar) {
      if (bar._st) return;
      bar._st = 1;
      var sentinel = d.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'height:0;margin:0;padding:0;';
      bar.parentNode.insertBefore(sentinel, bar);
      scrollers.push(function () {
        var stuck = sentinel.getBoundingClientRect().top < bar.getBoundingClientRect().top - 1;
        if (stuck !== bar.classList.contains('is-stuck')) bar.classList.toggle('is-stuck', stuck);
      });
    });
  }

  /* =========================================================
     boot
     ========================================================= */
  function init(scope) {
    scope = scope || d;
    initScrolly(scope);
    initContact(scope);
    initFaq(scope);
    initWiden(scope);
    initSticky(scope);
    onScroll();
  }
  function boot() { init(d); Cart.boot(); }
  w.CSPages = { cart: Cart, refresh: init };
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', measure);
  w.addEventListener('load', measure);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); Cart.boot(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
